import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconXModule } from "@mk/med-icons";

import { MedModalComponent } from "./med-modal.component";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedModalComponent,
  ],
  imports: [
    CommonModule,
    MedIconXModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedModalComponent,
  ],
})
export class MedModalModule { }
